<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-row>
      <v-col cols="12" xs="12" class="pa-0">
        <TableCompanies></TableCompanies>
      </v-col>
      <v-col cols="12" xs="12" sm="12">
        <v-row>
        <v-btn @click="downloadStats()" color="secondary" v-if="isCreateAllowed()">Statistik download</v-btn>
        <v-spacer></v-spacer>
        <v-btn @click="createItem()" color="primary" v-if="isCreateAllowed()" class="mx-2">Neu erstellen</v-btn>
        <v-btn @click="createItemVeranstalter()" color="primary" v-if="isCreateAllowed()">Veranstalter erstellen</v-btn>
        </v-row>
      </v-col>
    </v-row>
</template>

<script>
import Vue from 'vue'
import TableCompanies from './../tables/TableCompanies'

export default {
  name: 'Firmen',
  components: {TableCompanies},
  data () {
    return {
      search: null,
      headers: [
        {text: 'Name', align: 'left', value: 'name'},
        {text: 'Adresse', value: 'address'},
        /*{text: 'Strasse', value: 'street'},
        {text: 'PLZ', value: 'postcode'},
        {text: 'Stadt', value: 'city'},*/
        {text: 'E-Mail', value: 'email'},
        {text: 'Telefon', value: 'phonenumber'},
        {text: 'Aktion', value: 'action'}
        /*{text: 'Erstellt', value: 'created'},
        {text: 'Kommentar', value: 'comment'}
         */
      ],
      deviceList: []
    }
  },
  methods: {
    openCompanyDialog: function (item) {
      console.log('openCompanyDialog', item)
    },
    createItem: function () {
      console.log('createItem')
      Vue.prototype.$apiCompany.createCompany({
        isMother: 1
      }, this.onCompanyCreated)
    },
    onDownloadStats: function () {
      console.log('onDownloadStats')
    },
    downloadStats: function () {
      console.log('downloadStats')
      Vue.prototype.$apiCompany.exportToCSV({}, this.onDownloadStats)
    },

    createItemVeranstalter: function () {
      Vue.prototype.$apiCompany.createCompany({
        typ: 1,
        isMother: 1
      }, this.onCompanyCreated)
    },

    onCompanyCreated: function (newItem) {

      this.$router.push('/Netzwerke/' + newItem.guid)
    },
    getHDStyle: function (item) {
      var style = ''
      var prz = (100 / item.diskUsageMax) * item.diskUsageCurrent

      if (prz < 80) {
        style = 'color: green'
      } else {
        style = 'color: orange'
      }
      if (prz > 95) {
        style = 'color: red'
      }
      return style
    },
    getCompanyStyle: function (item) {
      var style = ''
      if (!item.company) {
        style = 'color: orange'
      }
      return style
    },
    editItem: function (item) {
      this.$router.push('/Netzwerke/' + item.guid)
    },
    deleteItem: function (item) {
      Vue.prototype.$apiCompany.deleteCompany(item.guid, this.reload)
    },
    reload: function () {
      // Vue.prototype.$apiCompany.loadCompanies(null, this.onGetData)
    },
    toMB: function (bytes, decimals) {
      if (bytes == 0) return '0 Bytes';
      var k = 1024,
      dm = decimals <= 0 ? 0 : decimals || 2,
      sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
      i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    isCreateAllowed: function () {
      return Vue.prototype.$apiRight.hasRight('RIGHT_NETWORK_CREATE', {})
    },
    onGetData: function (result) {
      console.log('result', result)
      this.deviceList = result
    }
  },
  mounted () {
    this.reload()
  }
}
</script>

<style scoped>

</style>
